import styled from 'styled-components';
import { InputField, Typography } from '#ui-kit';

export const DeliveryStepContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 16px;

  & > div {
    flex: 1;
    align-self: start;
  }
`;

export const DeliveryStepRemoveBtn = styled.button``;

export const DeliverySettingInputField = styled(InputField)`
  flex: 1;

  & input {
    width: 100%;
    min-width: unset !important;
  }
`;

export const DeliverySettingTitle = styled(Typography)`
  width: 100%;
`;
